import and from 'ember-truth-helpers/helpers/and';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type { WebPSURLs } from 'parog-web/cnam/types';

export default <template>
  <div class='mt-[60px] flex w-full justify-center' data-test-web-ps-links>
    {{#if (and @webPSUrls.medicDashboardURL @webPSUrls.patientFolderURL)}}
      Accès Web PS :
      <a
        data-test-medic-dashboard-link
        href={{@webPSUrls.medicDashboardURL}}
      >Tableau de bord</a>&nbsp;|&nbsp;<a
        data-test-patient-folder-link
        href={{@webPSUrls.patientFolderURL}}
      >Dossier patient</a>
    {{/if}}
  </div>
</template> satisfies TemplateOnlyComponent<{
  Args: { webPSUrls: WebPSURLs | undefined };
}>;
